// extracted by mini-css-extract-plugin
export default {"GitHubIcon":"GitHubIcon_GitHubIcon__Jy--c"};